import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';
import { CouponPreviewDetailsType } from '../shared';
import { CheckoutData } from 'src/shared/types/checkout';

type ConfirmTrialSessionPaymentParams = {
  paymentIntentId: string;
  couponPreviewDetails?: CouponPreviewDetailsType | null;
};
export const confirmTrialSessionPayment = async ({
  paymentIntentId,
  couponPreviewDetails,
}: ConfirmTrialSessionPaymentParams) => {
  const { data: confirmResponse } = await HttpHandler({
    url: `${environment.STRIPE_PAYMENTS_APP_URL}/payment-intent/${paymentIntentId}/confirm`,
    method: 'POST',
    data: { couponPreview: couponPreviewDetails ?? undefined },
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return confirmResponse.data;
};

type CreateBalanceByTariffParams = {
  selectedPriceId: string;
  clientEmail: string;
  onboardingKey: string;
  useAdditionalPromotionalCodeDiscount: boolean | null;
};

export const createBalanceByTariff = async (data: CreateBalanceByTariffParams) => {
  const { data: confirmResponse } = await HttpHandler<{ data: CheckoutData }>({
    url: `${environment.STRIPE_PAYMENTS_APP_URL}/payment-intent/balance`,
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return confirmResponse.data;
};
